var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paragrafo"},[_c('div',{staticClass:"titolo",on:{"click":_vm.triggerAperto}},[_c('div',[_vm._t("titolo")],2)]),_c('div',{staticClass:"testo",class:{'aperto':_vm.aperto}},[_c('div',[_vm._t("contenuto")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }